module.exports = __webpack_public_path__ + "static/media/beru-whitesun-lars.c4a75ce1.jpg";